export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5291.78b9aaa8.jpg";